import React from "react";
import ReactApexChart from "react-apexcharts";

const PhdFacultyPercentageChart = ({
  phdData = [],
  nonPhdData = [],
  categories = [],
  title = "مقارنة نسبة حملة الدكتوراه وغير الحاصلين عليها في الجامعات",
  colors = ["#FFAB2D", "#AC4CBC"],
  height = 320,
}) => {
  const series = [
    {
      name: "حملة الدكتوراه",
      data: phdData,
    },
    {
      name: "غير حملة الدكتوراه",
      data: nonPhdData,
    },
  ];

  const options = {
    chart: {
      height,
      toolbar: { show: false },
      type: "area",
    },
    colors: colors.slice(0, 2),
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "center",
      fontFamily: "Cairo",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 3,
      curve: "smooth",
    },
    fill: {
      opacity: 0.3,
      type: "solid",
    },
    xaxis: {
      categories,
      labels: {
        style: {
          fontFamily: "Cairo",
        },
      },
      title: {
        text: "الجامعات",
        style: {
          fontSize: "14px",
          fontFamily: "Cairo",
        },
      },
    },
    yaxis: {
      min: 0,
      max: 100,
      labels: {
        formatter: (val) => `${val}%`,
        style: {
          fontFamily: "Cairo",
        },
      },
      title: {
        text: "النسبة المئوية",
        style: {
          fontFamily: "Cairo",
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val.toFixed(2)}%`,
      },
    },
  };

  return (
    <div className="card mt-4 p-3">
      <h5 className="mb-3" style={{ fontFamily: "Cairo" }}>{title}</h5>
      <ReactApexChart options={options} series={series} type="area" height={height} />
    </div>
  );
};

export default PhdFacultyPercentageChart;
